import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import {
  getConnectedRepos,
  getForgejoRepos,
  type ConnectedReposResponse,
  type ForgejoReposResponse,
} from "./api";

// Хук «список репо у Forgejo-аккаунта» (все доступные user'у). Org-scoped
// запрос (см. `src/query/scope.ts`). Включается только когда
// `enabled === true` (вызывается со `status.connected === true` со
// страницы — иначе backend вернёт 404, у org ещё нет ForgejoCredential).
export function useForgejoRepos(
  enabled: boolean,
): UseQueryResult<ForgejoReposResponse, Error> {
  return useOrgScopedQuery<ForgejoReposResponse>({
    key: ["connections", "forgejo", "repos"],
    queryFn: () => getForgejoRepos(),
    enabled,
    retry: false,
    // staleTime 30s — Forgejo /user/repos дёргает реальный upstream;
    // react-query refetch при window-focus без этого тротлинга
    // создаёт лишнюю нагрузку и риск rate-limit'а на proxy.
    staleTime: 30_000,
  });
}

// Подключённые репо — отдельный список, независимый от полного
// каталога. Backend возвращает `repos: string[]` (full_name) без
// html_url; подключать full ForgejoRepoSummary здесь не нужно.
export function useConnectedForgejoRepos(
  enabled: boolean,
): UseQueryResult<ConnectedReposResponse, Error> {
  return useOrgScopedQuery<ConnectedReposResponse>({
    key: ["connections", "forgejo", "repos", "connected"],
    queryFn: () => getConnectedRepos(),
    enabled,
    retry: false,
    // staleTime 30s — Forgejo /user/repos дёргает реальный upstream;
    // react-query refetch при window-focus без этого тротлинга
    // создаёт лишнюю нагрузку и риск rate-limit'а на proxy.
    staleTime: 30_000,
  });
}
